var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetweet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.07315 0.157973C4.8277 -0.0526577 4.42974 -0.0526574 4.18429 0.157973L0.93061 2.95008C0.623797 3.21337 0.623797 3.64024 0.93061 3.90353C1.23742 4.16682 1.73487 4.16682 2.04168 3.90353L3.84308 2.35768V10.4384C3.84308 12.3001 5.6018 13.8093 7.7713 13.8093H12.7994C13.2333 13.8093 13.5851 13.5075 13.5851 13.1352C13.5851 12.7628 13.2333 12.461 12.7994 12.461H7.7713C6.4696 12.461 5.41437 11.5554 5.41437 10.4384V2.35768L7.21576 3.90353C7.52258 4.16682 8.02002 4.16682 8.32683 3.90353C8.63365 3.64024 8.63365 3.21337 8.32683 2.95008L5.07315 0.157973Z",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7973 13.842C19.0427 14.0527 19.4407 14.0527 19.6861 13.842L22.9398 11.0499C23.2466 10.7866 23.2466 10.3598 22.9398 10.0965C22.633 9.83318 22.1356 9.83318 21.8287 10.0965L20.0273 11.6423V3.5616C20.0273 1.69988 18.2686 0.190649 16.0991 0.190649H11.071C10.6371 0.190649 10.2854 0.492495 10.2854 0.86484C10.2854 1.23719 10.6371 1.53903 11.071 1.53903H16.0991C17.4008 1.53903 18.4561 2.44457 18.4561 3.5616V11.6423L16.6547 10.0965C16.3478 9.83318 15.8504 9.83318 15.5436 10.0965C15.2368 10.3598 15.2368 10.7866 15.5436 11.0499L18.7973 13.842Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetweet);
export default __webpack_public_path__ + "static/media/retweet.1810071e087878fd1eeef598e6959e0a.svg";
export { ForwardRef as ReactComponent };